function MediaSection() {
  const items = [
    { title: '封神第二部：战火西岐', tag: '预告片', dur: '02:35', img: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20fantasy%20film%20scene%20with%20ancient%20battlefield%2C%20warriors%20in%20traditional%20armor%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20cinematic%20wide%20shot%2C%20grand%20scale%20composition%2C%20warm%20epic%20lighting&width=700&height=400&seq=media-01&orientation=landscape', alt: '封神第二部预告' },
    { title: '哪吒之魔童闹海幕后特辑', tag: '花絮', dur: '05:18', img: 'https://readdy.ai/api/search-image?query=Animated%20film%20behind%20the%20scenes%20with%20creative%20studio%20environment%2C%20artists%20working%20on%20character%20designs%2C%20colorful%20concept%20art%20on%20walls%2C%20warm%20creative%20atmosphere%2C%20professional%20animation%20studio%20setting&width=700&height=400&seq=media-02&orientation=landscape', alt: '哪吒幕后特辑' },
    { title: '碟中谍8：最终清算独家专访', tag: '采访', dur: '08:42', img: 'https://readdy.ai/api/search-image?query=Film%20interview%20setting%20with%20professional%20lighting%20setup%2C%20movie%20posters%20in%20background%2C%20cinematic%20studio%20environment%2C%20warm%20ambient%20lighting%2C%20elegant%20furniture%2C%20professional%20film%20production%20atmosphere&width=700&height=400&seq=media-03&orientation=landscape', alt: '碟中谍8专访' },
    { title: '2026暑期档观影指南', tag: '盘点', dur: '12:20', img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20with%20colorful%20film%20posters%20on%20display%2C%20bright%20natural%20light%20streaming%20through%20windows%2C%20cinema%20lobby%20atmosphere%2C%20excitement%20and%20anticipation%2C%20warm%20vibrant%20color%20palette&width=700&height=400&seq=media-04&orientation=landscape', alt: '暑期档观影指南' },
    { title: '国产科幻电影十年回顾', tag: '纪录片', dur: '15:06', img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20style%20montage%20of%20sci%20fi%20movie%20scenes%2C%20futuristic%20visual%20effects%20and%20space%20imagery%2C%20cinematic%20retrospective%20aesthetic%2C%20deep%20space%20and%20technology%20themes%2C%20dramatic%20contrast%20lighting&width=700&height=400&seq=media-05&orientation=landscape', alt: '国产科幻十年回顾' },
  ];

  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">精彩预告</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">热门电影预告片、幕后花絮与独家专访，提前感受光影魅力</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {items.map((item, i) => (
            <div key={i} className="rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-colors duration-200 cursor-pointer group">
              <div className="aspect-video overflow-hidden bg-secondary-100 relative">
                <img src={item.img} alt={item.alt} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-background-950/60 group-hover:bg-primary-500 transition-colors duration-200">
                    <i className="ri-play-fill text-xl text-background-50"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-background-950/70 text-background-50 text-xs font-medium whitespace-nowrap">{item.dur}</span>
              </div>
              <div className="p-3 md:p-4">
                <span className="inline-block px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs font-medium mb-1.5 whitespace-nowrap">{item.tag}</span>
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">关于星空电影网</h2>
        <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
          <p>
            星空电影网创立于2020年，致力于为广大影迷打造一个<strong>纯粹、免费、高清</strong>的在线观影平台。五年深耕，我们已积累了超过50,000部中外影片资源，涵盖动作片、喜剧片、科幻片、悬疑片、动画片等全品类，每日片库持续更新。
          </p>
          <p>
            我们坚持"观影零门槛"原则——无需注册、无需付费、无需下载插件，打开网页即可享受1080P高清画质的流畅播放体验。每一部影片都经过精心筛选与画质优化，确保为观众呈现最佳视听效果。星空电影网，让好电影触手可及。
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-8 mt-8">
          <div className="text-center">
            <div className="font-heading text-3xl font-bold text-primary-600">5+</div>
            <div className="text-xs text-foreground-500 mt-1">运营年限</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-3xl font-bold text-primary-600">50K+</div>
            <div className="text-xs text-foreground-500 mt-1">影片资源</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-3xl font-bold text-primary-600">8M+</div>
            <div className="text-xs text-foreground-500 mt-1">月活跃影迷</div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FeaturesSection() {
  const features = [
    { icon: 'ri-4k-line', title: '高清画质', desc: '全站影片支持1080P超清播放，热门新片提供4K画质选项，智能码率自适应流畅不卡顿。' },
    { icon: 'ri-stack-line', title: '海量片库', desc: '超50,000部中外影片，覆盖动作、喜剧、科幻、悬疑等全品类，每日更新片源不断。' },
    { icon: 'ri-flashlight-line', title: '极速播放', desc: '全球CDN加速节点覆盖，即点即播零等待，无论PC还是手机都能享受丝滑流畅观影。' },
  ];

  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">平台特色</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">为什么超过800万影迷选择星空电影网</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((f, i) => (
            <div key={i} className="text-center p-6 md:p-8 rounded-lg bg-background-100 border border-background-200/70">
              <span className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className={`${f.icon} text-2xl text-primary-600`}></i>
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function IndexSection() {
  const categories = [
    { name: '动作片', count: '8,200+', icon: 'ri-sword-line', desc: '热血激战、飙车枪战，肾上腺素爆表' },
    { name: '喜剧片', count: '6,500+', icon: 'ri-emotion-happy-line', desc: '爆笑不断，欢乐解压最佳选择' },
    { name: '科幻片', count: '4,300+', icon: 'ri-rocket-line', desc: '探索未来，感受想象力的极限' },
    { name: '悬疑片', count: '5,100+', icon: 'ri-search-eye-line', desc: '烧脑反转，层层推进的惊悚之旅' },
    { name: '爱情片', count: '7,800+', icon: 'ri-heart-line', desc: '浪漫温情，感动心灵的情感故事' },
    { name: '动画片', count: '4,600+', icon: 'ri-palette-line', desc: '国漫崛起，全年龄段的视觉盛宴' },
    { name: '恐怖片', count: '2,900+', icon: 'ri-ghost-line', desc: '胆量挑战，深夜独自观影慎入' },
  ];

  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">分类索引</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">按类型快速找到你想看的电影，片库分类一目了然</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3 md:gap-4">
          {categories.map((c, i) => (
            <div key={i} className="rounded-lg bg-background-50 border border-background-200/70 p-4 md:p-5 text-center hover:border-primary-200/50 transition-colors duration-200 cursor-pointer group">
              <span className="w-10 h-10 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${c.icon} text-lg text-primary-600`}></i>
              </span>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1">{c.name}</h3>
              <div className="text-xs text-primary-600 font-medium mb-2">{c.count} 部</div>
              <p className="text-xs text-foreground-400 leading-relaxed line-clamp-2">{c.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function UpdatesSection() {
  const updates = [
    { date: '08-01', title: '《封神第二部》高清版今日上线', tag: '新片' },
    { date: '07-31', title: '暑期档专题「国产科幻崛起」重磅更新', tag: '专题' },
    { date: '07-30', title: '《奥本海默》导演剪辑版独家引进', tag: '新片' },
    { date: '07-29', title: '片库突破50,000部，全站画质升级公告', tag: '公告' },
    { date: '07-28', title: '成龙动作片经典特辑周末限时连播', tag: '活动' },
    { date: '07-27', title: '《八角笼中》观影人数突破百万大关', tag: '热门' },
    { date: '07-26', title: '移动端播放器全面优化，加载速度提升40%', tag: '优化' },
    { date: '07-25', title: '《消失的她》持续霸榜，悬疑片热度飙升', tag: '热门' },
    { date: '07-24', title: '星空电影网全新首页改版上线', tag: '公告' },
  ];

  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-2">最新快讯</h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">片库动态、新片上线、平台公告，第一时间掌握星空电影网最新消息</p>

        <div className="relative pl-8 md:pl-10 border-l-2 border-secondary-200">
          {updates.map((u, i) => (
            <div key={i} className="relative pb-7 last:pb-0">
              <span className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></span>
              <div className="flex items-start gap-3">
                <span className="shrink-0 text-xs font-bold text-primary-600 bg-primary-100 px-2 py-0.5 rounded whitespace-nowrap">{u.date}</span>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className={`shrink-0 px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                      u.tag === '新片' ? 'bg-accent-100 text-accent-700' :
                      u.tag === '公告' ? 'bg-secondary-100 text-secondary-700' :
                      'bg-primary-100 text-primary-700'
                    }`}>{u.tag}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 font-medium">{u.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-8 bg-gradient-to-r from-primary-500 to-accent-500">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">随时随地 · 手机观影</h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-6">
              星空电影网全面适配手机浏览器访问，无需下载App即可在移动端享受与PC端一致的1080P高清观影体验。通勤路上、午休时刻、睡前放松，好电影伴你每一刻。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 text-primary-600 font-semibold text-sm cursor-pointer hover:bg-background-100 transition-colors whitespace-nowrap">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-smartphone-line"></i></span>
                手机端立即体验
              </span>
              <span className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-50/30 text-background-50 font-medium text-sm cursor-pointer hover:bg-background-50/10 transition-colors whitespace-nowrap">
                <span className="w-5 h-5 flex items-center justify-center"><i className="ri-qr-code-line"></i></span>
                扫码打开
              </span>
            </div>
          </div>
          <div className="shrink-0 w-48 md:w-56 aspect-[9/16] rounded-lg overflow-hidden bg-background-50/10 border border-background-50/20">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20movie%20streaming%20mobile%20app%20interface%20design%20with%20film%20posters%20grid%20layout%2C%20clean%20minimal%20UI%20with%20warm%20dark%20theme%2C%20movie%20thumbnails%20in%20card%20style%2C%20navigation%20bar%20at%20bottom%2C%20professional%20app%20screenshot%20mockup%2C%20cinematic%20aesthetic&width=560&height=996&seq=app-screen-01&orientation=portrait"
              alt="星空电影网手机端界面"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}


export default function SectionsLower() {
  return (
    <>
      <MediaSection />
      <AboutSection />
      <FeaturesSection />
      <IndexSection />
      <UpdatesSection />
      <AppSection />
    </>
  );
}

export { MediaSection, AboutSection, FeaturesSection, IndexSection, UpdatesSection, AppSection };